import api from './api';

export const listExitAuthorizations = (params = {}) => api.get('/exit-authorizations', { params });
export const getExitAuthorization = (id) => api.get(`/exit-authorizations/${id}`);
export const createExitAuthorization = (data) => api.post('/exit-authorizations', data);

export default { listExitAuthorizations, getExitAuthorization, createExitAuthorization };
